import { forwardRef } from 'react';
import { cx } from '@emotion/css';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

import FieldGroup from '../field-group';

import { AutocompleteBaseProps } from './types';
import { selectCx } from './styles';

const AutocompleteBase = forwardRef<HTMLDivElement, AutocompleteBaseProps>(
  (props, ref) => {
    const {
      name,
      helperText,
      label,
      value,
      className,
      selectClassName,
      options,
      isInvalid,
      error,
      ...resProps
    } = props;
    return (
      <FieldGroup
        invalid={isInvalid}
        error={error}
        helperText={helperText}
        className={className}
        ref={ref}
        name={name}
      >
        <FormControl>
          <InputLabel style={{ fontSize: 13 }}>{label}</InputLabel>
          <Autocomplete
            {...resProps}
            disablePortal
            className={cx(selectClassName, selectCx)}
            options={options}
            data-filled={Boolean(value)}
            value={value}
            renderInput={(params) => (
              <TextField
                {...params}
                autoComplete='off'
                name={name}
                variant='standard'
              />
            )}
          />
        </FormControl>
      </FieldGroup>
    );
  },
);

export default AutocompleteBase;
